import { createStore } from "vuex";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../auth-config";

const msalInstance = new PublicClientApplication(msalConfig); // Initialize MSAL

const store = createStore({
  state: {
    languageOption: localStorage.getItem("languageOption") || "ENGLISH",
    msalInstance: msalInstance,
    loading: false,
    userAuthProvider: null,
    userSSOAuthMethod: null,
    username: localStorage.username,
    resetSelectedOrganizationAndWorkspace: false,
    ismyissuestoggled: false,
    ismobileauthorized: false,
    hasWorkspaceAuthorization: false,
    isOwner: false,
    isusepincodeformobileauth:
      typeof localStorage.isusepincodeformobileauth === "string"
        ? localStorage.isusepincodeformobileauth.toLowerCase() === "true"
        : localStorage.isusepincodeformobileauth,
    isauthorized:
      typeof localStorage.isauthorized === "string"
        ? localStorage.isauthorized.toLowerCase() === "true"
        : localStorage.isauthorized,
    isadministrator:
      typeof localStorage.isadministrator === "string"
        ? localStorage.isadministrator.toLowerCase() === "true"
        : localStorage.isadministrator,
    issuperadministrator:
      typeof localStorage.issuperadministrator === "string"
        ? localStorage.issuperadministrator.toLowerCase() === "true"
        : localStorage.issuperadministrator,
    useForms:
      typeof localStorage.useForms === "string"
        ? localStorage.useForms.toLowerCase() === "true"
        : localStorage.useForms,
    isQrCodeRegistered:
      typeof localStorage.isQrCodeRegistered === "string"
        ? localStorage.isQrCodeRegistered.toLowerCase() === "true"
        : localStorage.isQrCodeRegistered,
    bearertoken: localStorage.bearertoken,
    errordialog: false,
    errormessage: null,
    workingdialog: false,
    sort: localStorage.sort,
    organizationid:
      typeof localStorage.organizationid === "string"
        ? Number(localStorage.organizationid)
        : localStorage.organizationid,
    workspaceid:
      typeof localStorage.workspaceid === "string" ? Number(localStorage.workspaceid) : localStorage.workspaceid,
    legacyworkspaceid:
      typeof localStorage.legacyworkspaceid === "string"
        ? Number(localStorage.legacyworkspaceid)
        : localStorage.legacyworkspaceid,
    organizationitems: [],
    workspaceitems: [],
    legacyMobileParams: localStorage.legacyMobileParams,
    mobileParams: localStorage.mobileParams,
    redirectRoute: null,
  },
  getters: {
    languageOption: (state) => {
      return state.languageOption;
    },
    msalInstance: (state) => {
      return state.msalInstance;
    },
    hasWorkspaceAuthorization: (state) => {
      return state.hasWorkspaceAuthorization;
    },
    isOwner: (state) => {
      return state.isOwner;
    },
    loading: (state) => {
      return state.loading;
    },
    userSSOAuthMethod: (state) => {
      return state.userSSOAuthMethod;
    },
    userAuthProvider: (state) => {
      return state.userAuthProvider;
    },
    username: (state) => {
      return state.username;
    },
    isauthorized: (state) => {
      return state.isauthorized;
    },
    ismobileauthorized: (state) => {
      return state.ismobileauthorized;
    },
    isusepincodeformobileauth: (state) => {
      return state.isusepincodeformobileauth;
    },
    ismyissuestoggled: (state) => {
      return state.ismyissuestoggled;
    },
    useForms: (state) => {
      return state.useForms;
    },
    isQrCodeRegistered: (state) => {
      return state.isQrCodeRegistered;
    },
    resetSelectedOrganizationAndWorkspace: (state) => {
      return state.resetSelectedOrganizationAndWorkspace;
    },
    isadministrator: (state) => {
      return state.isadministrator === true ? true : state.isadministrator === "true" ? true : false;
    },
    issuperadministrator: (state) => {
      return state.issuperadministrator === true ? true : state.issuperadministrator === "true" ? true : false;
    },
    bearertoken: (state) => {
      return state.bearertoken;
    },
    errordialog: (state) => {
      return state.errordialog;
    },
    errormessage: (state) => {
      return state.errormessage;
    },
    workingdialog: (state) => {
      return state.workingdialog;
    },
    sort: (state) => {
      return JSON.parse(state.sort);
    },
    organizationid: (state) => {
      return state.organizationid ? parseInt(localStorage.getItem("organizationid")) : 1;
    },

    workspaceid: (state) => {
      if (state.workspaceid == undefined) {
        localStorage.workspaceid = 1;
        return localStorage.workspaceid;
      }
      return state.workspaceid;
    },
    legacyMobileParams: (state) => {
      return state.legacyMobileParams;
    },
    mobileParams: (state) => {
      return state.mobileParams;
    },
    legacyworkspaceid: (state) => {
      return state.legacyworkspaceid;
    },
    islegacy: (state) => {
      return parseInt(state.legacyworkspaceid) === parseInt(state.workspaceid);
    },
    organizationitems: (state) => {
      return state.organizationitems;
    },
    workspaceitems: (state) => {
      return state.workspaceitems;
    },
    redirectRoute: (state) => {
      return state.redirectRoute;
    },
  },
  mutations: {
    setOrganizationId(state, id) {
      state.organizationid = id;
      localStorage.setItem("organizationid", id);
    },
    setLanguageOption(state, language) {
      state.languageOption = language;
      localStorage.setItem("languageOption", language);
    },
    initStorage(state) {
      if (localStorage.username === "undefined") {
        localStorage.username = state.username === undefined ? "" : state.username;
      }
      if (localStorage.ismyissuestoggled === "undefined") {
        localStorage.ismyissuestoggled = state.ismyissuestoggled === undefined ? "" : state.ismyissuestoggled;
      }
      if (localStorage.organizationid === "undefined") {
        localStorage.organizationid = state.organizationid === undefined ? "" : state.organizationid;
      }
      if (localStorage.workspaceid === "undefined") {
        localStorage.workspaceid = state.workspaceid === undefined ? "" : state.workspaceid;
      }
      if (localStorage.legacyworkspaceid === "undefined") {
        localStorage.legacyworkspaceid = state.legacyworkspaceid === undefined ? "" : state.legacyworkspaceid;
      }
      if (localStorage.bearertoken === "undefined") {
        localStorage.bearertoken = state.bearertoken === undefined ? "" : state.bearertoken;
      }
      if (localStorage.isauthorized === "undefined") {
        localStorage.isauthorized = state.isauthorized === undefined ? false : state.isauthorized;
      }
      if (localStorage.ismobileauthorized === "undefined") {
        localStorage.ismobileauthorized = state.ismobileauthorized === undefined ? false : state.ismobileauthorized;
      }
      if (localStorage.useForms === "undefined") {
        localStorage.useForms = state.useForms === undefined ? false : state.useForms;
      }
      if (localStorage.isusepincodeformobileauth === "undefined") {
        localStorage.isusepincodeformobileauth =
          state.isusepincodeformobileauth === undefined ? false : state.isusepincodeformobileauth;
      }
      if (localStorage.isQrCodeRegistered === "undefined") {
        localStorage.isQrCodeRegistered = state.isQrCodeRegistered === undefined ? false : state.isQrCodeRegistered;
      }
      if (localStorage.sort === undefined) {
        const sortObj = { sortBy: [""], sortDesc: [false] };

        state.sort = JSON.stringify({
          issueSort: { sortBy: ["created"], sortDesc: [true] },
          qrSort: sortObj,
          inventorySort: sortObj,
          statisticSort: sortObj,
          userSort: sortObj,
          qrCategorySort: sortObj,
          locationSort: sortObj,
        });

        localStorage.sort = JSON.stringify({
          issueSort: { sortBy: ["created"], sortDesc: [true] },
          qrSort: sortObj,
          inventorySort: sortObj,
          statisticSort: sortObj,
          userSort: sortObj,
          qrCategorySort: sortObj,
          locationSort: sortObj,
        });
      }
    },
    saveAuthorization(state, authinfo) {
      state.username = authinfo.username;
      state.isauthorized = authinfo.isauthorized;
      state.bearertoken = authinfo.bearertoken;
      state.isadministrator = authinfo.isadministrator;
      state.issuperadministrator = authinfo.issuperadministrator;
      state.isOwner = authinfo.isOwner;
      state.hasWorkspaceAuthorization = authinfo.hasWorkspaceAuthorization;
      state.userAuthProvider = authinfo.userAuthProvider;

      localStorage.username = authinfo.username;
      localStorage.isauthorized = authinfo.isauthorized;
      localStorage.bearertoken = authinfo.bearertoken;
      localStorage.isadministrator = authinfo.isadministrator;
      localStorage.issuperadministrator = authinfo.issuperadministrator;
    },
    saveBearerToken(state, token) {
      state.bearertoken = token;
      localStorage.bearertoken = token;
    },
    saveMobileAuth(state, authinfo) {
      state.ismobileauthorized = authinfo.ismobileauthorized;
      localStorage.ismobileauthorized = authinfo.ismobileauthorized;
    },
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    usePinCodeForMobileAuth(state) {
      state.isusepincodeformobileauth = true;
      localStorage.isusepincodeformobileauth = true;
    },
    saveMyIssuesToggle(state, isToggled) {
      state.ismyissuestoggled = isToggled;
      localStorage.ismyissuestoggled = isToggled;
    },
    saveOrganizationId(state, organizationid) {
      state.organizationid = organizationid;
      localStorage.organizationid = organizationid;
    },
    saveWorkspaceId(state, workspaceid) {
      state.workspaceid = workspaceid;
      localStorage.workspaceid = workspaceid;
    },
    saveLegacyWorkspaceId(state, legacyworkspaceid) {
      state.legacyworkspaceid = legacyworkspaceid;
      localStorage.legacyworkspaceid = legacyworkspaceid;
    },
    saveLegacyMobileParams(state, params) {
      state.legacyMobileParams = params;
      localStorage.legacyMobileParams = params;
    },
    saveMobileParams(state, params) {
      state.mobileParams = params;
      localStorage.mobileParams = params;
    },
    saveUserSSOAuthMethod(state, userSSOAuthMethod) {
      state.userSSOAuthMethod = userSSOAuthMethod;
    },
    doesOrganizationUseForms(state, useForms) {
      state.useForms = useForms;
      localStorage.useForms = useForms;
    },
    saveQrCodeStatus(state, isRegistered) {
      state.isQrCodeRegistered = isRegistered;
      localStorage.isQrCodeRegistered = isRegistered;
    },
    resetSelectedOrganizationAndWorkspace(state) {
      state.resetSelectedOrganizationAndWorkspace = !state.resetSelectedOrganizationAndWorkspace;
    },
    deleteAuthorization(state) {
      state.username = null;
      state.bearertoken = null;
      state.userAuthProvider = null;
      state.isauthorized = false;
      state.isadministrator = false;
      state.issuperadministrator = false;
      state.isOwner = false;
      state.hasWorkspaceAuthorization = false;

      delete localStorage.username;
      delete localStorage.isauthorized;
      delete localStorage.bearertoken;
      delete localStorage.isadministrator;
      delete localStorage.issuperadministrator;
    },
    deleteMobileAuth(state) {
      state.ismobileauthorized = false;
      localStorage.ismobileauthorized = false;
    },
    dontUsePinCodeForMobileAuth(state) {
      state.isusepincodeformobileauth = false;
      localStorage.isusepincodeformobileauth = false;
    },
    showError(state, errormessage) {
      state.errormessage = errormessage;
      state.errordialog = true;
    },
    clearError(state) {
      state.errordialog = false;
      state.errormessage = null;
    },
    showWorkingStatus(state) {
      state.workingdialog = true;
    },
    clearWorkingStatus(state) {
      state.workingdialog = false;
    },
    updateSort(state, sortInfo) {
      state.sort = JSON.stringify(sortInfo);
      localStorage.sort = JSON.stringify(sortInfo);
    },
    addOrganizationitem(state, item) {
      state.organizationitems.push(item);
    },
    deleteOrganizationitem(state, item) {
      var itemindex = state.organizationitems.findIndex((oi) => oi.id === item.id);
      state.organizationitems.splice(itemindex, 1);
    },
    clearOrganizationitems(state) {
      state.organizationitems = [];
    },
    addWorkspaceitem(state, item) {
      state.workspaceitems.push(item);
    },
    deleteWorkspaceitem(state, item) {
      var itemindex = state.workspaceitems.findIndex((w) => w.id === item.id);
      state.workspaceitems.splice(itemindex, 1);
    },
    clearWorkspaceitems(state) {
      state.workspaceitems = [];
    },
    setRedirectRoute(state, route) {
      state.redirectRoute = route;
    },
  },
  actions: {
    setOrganizationId({ commit }, id) {
      commit("setOrganizationId", id);
    },
    setLanguageOption({ commit }, language) {
      commit("setLanguageOption", language);
    },
    initStorage({ commit }) {
      commit("initStorage", null);
    },
    setLoading({ commit }, isLoading) {
      commit("setLoading", isLoading);
    },
    saveAuthorization({ commit }, authinfo) {
      commit("saveAuthorization", authinfo);
    },
    saveBearerToken({ commit }, token) {
      commit("saveBearerToken", token);
    },
    saveMobileAuth({ commit }, authinfo) {
      commit("saveMobileAuth", authinfo);
    },
    usePinCodeForMobileAuth({ commit }) {
      commit("usePinCodeForMobileAuth");
    },
    saveMyIssuesToggle({ commit }, isToggled) {
      commit("saveMyIssuesToggle", isToggled);
    },
    saveOrganizationId({ commit }, organizationid) {
      commit("saveOrganizationId", organizationid);
    },
    saveWorkspaceId({ commit }, workspaceid) {
      commit("saveWorkspaceId", workspaceid);
    },
    saveLegacyWorkspaceId({ commit }, legacyworkspaceid) {
      commit("saveLegacyWorkspaceId", legacyworkspaceid);
    },
    saveLegacyMobileParams({ commit }, legacyMobileParams) {
      commit("saveLegacyMobileParams", legacyMobileParams);
    },
    saveMobileParams({ commit }, mobileParams) {
      commit("saveMobileParams", mobileParams);
    },
    saveUserSSOAuthMethod({ commit }, userSSOAuthMethod) {
      commit("saveUserSSOAuthMethod", userSSOAuthMethod);
    },
    doesOrganizationUseForms({ commit }, useForms) {
      commit("doesOrganizationUseForms", useForms);
    },
    addOrganizationitem({ commit }, item) {
      commit("addOrganizationitem", item);
    },
    deleteOrganizationitem({ commit }, item) {
      commit("deleteOrganizationitem", item);
    },
    dontUsePinCodeForMobileAuth({ commit }) {
      commit("dontUsePinCodeForMobileAuth");
    },
    saveQrCodeStatus({ commit }, isRegistered) {
      commit("saveQrCodeStatus", isRegistered);
    },
    resetSelectedOrganizationAndWorkspace({ commit }) {
      commit("resetSelectedOrganizationAndWorkspace");
    },
    clearOrganizationitems({ commit }) {
      commit("clearOrganizationitems", null);
    },
    addWorkspaceitem({ commit }, item) {
      commit("addWorkspaceitem", item);
    },
    deleteWorkspaceitem({ commit }, item) {
      commit("deleteWorkspaceitem", item);
    },
    clearWorkspaceitems({ commit }) {
      commit("clearWorkspaceitems", null);
    },
    deleteAuthorization({ commit }) {
      commit("deleteAuthorization", null);
    },
    deleteMobileAuth({ commit }) {
      commit("deleteMobileAuth", null);
    },
    showError({ commit }, errormessage) {
      commit("showError", errormessage);
    },
    clearError({ commit }) {
      commit("clearError", null);
    },
    showWorkingStatus({ commit }) {
      commit("showWorkingStatus", null);
    },
    clearWorkingStatus({ commit }) {
      commit("clearWorkingStatus", null);
    },
    updateSort({ commit }, sortInfo) {
      commit("updateSort", sortInfo);
    },
    setRedirectRoute({ commit }, route) {
      commit("setRedirectRoute", route);
    },
  },
  modules: {},
});

export default store;
